module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/dashboard/components/footer/footer.component.scss
// module id = ./src/app/modules/dashboard/components/footer/footer.component.scss
// module chunks = main